import React from 'react';
import PropTypes from 'prop-types';
import { BootstrapModal } from 'shared-components/modal/bootstrap-modal';
import ModalFlowBody from './ModalFlowBody';
import ModalFlowFooter from './ModalFlowFooter';

const ModalFlowSteps = ({
  changeModal,
  body = {},
  nextModal,
  previousModal,
  length,
  index = 0,
  showModal,
  addCloseIcon,
  ...props
}) => {
  return (
    <BootstrapModal
      showModal={showModal}
      addCloseIcon={addCloseIcon}
      body={
        <ModalFlowBody
          {...body}
          {...props}
          ctaAction={() => changeModal(nextModal) }
        />
      }
      bodyClass="modal-flow-body text-center"
      footer={
        <ModalFlowFooter
          totalLength={length}
          currentIndex={index}
          backAction={() => changeModal(previousModal) }
        />
      }
      toggleModal={changeModal}
    />
  );
};

ModalFlowSteps.propTypes = {
  changeModal: PropTypes.func,
  showModal: PropTypes.bool,
  body: PropTypes.object,
  length: PropTypes.number,
  index: PropTypes.number,
  nextModal: PropTypes.string,
  previousModal: PropTypes.string,
  addCloseIcon: PropTypes.bool
};

export default ModalFlowSteps;
